const translations = {
  "common": {
    "callUs": "Call us",
    "emailUs": "Email us"
  },
  errors: {
    go_home: "Return to Homepage",
    not_found: "Page Not Found",
    not_found_message: "The page you are looking for does not exist or has been moved.",
    try_again: "Try Again",
    unexpected: "Sorry! An unexpected error occurred",
    unexpected_message: "We encountered an unexpected error. Please try again later.",
    server_error: "Server Error",
    server_error_message: "Our servers are currently experiencing issues. Please try again shortly.",
    offline: "You are offline",
    offline_message: "Please check your internet connection and try again."
},
  about: {
    operating: 'Operating Countries',
    expereince: 'Years of Excellence',
    clients: "Client Satisfaction",
    since: "Since",
  },
  loading: "Loading",
  fullscreen: "Full Screen",
  quote_btn: "Get Guote",
  learn_more: "Learn More",
  mission: {
    title: "Our Mission",
    description: "Mission Description"
  },
  coreValues: {
    title: "Core Values"
  },
  contact: {
    header_h1: "Build Your Dreams With Us",
    header_h2: "Transform your vision into reality with our expert construction services. Let's discuss your project and make it happen.",
    title: "Get in",
    titleColored: "Touch",
    subtitle: "Have questions? We're here to help. Send us a message and we'll respond as soon as possible.",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email Address",
    phone: "Phone Number",
    message: "Message",
    sendMessage: "Send Message",
    connectWithUs: "Connect With Us",
    emailUs: "Email Us",
    callUs: "Call Us",
    linkedin: "LinkedIn",
    twitter: "Twitter",
    viewMap: "View on Map",
    hero_title: "Build Your Dreams With Us",
    hero_subtitle: "Transform your vision into reality with our expert construction services. Let's discuss your project and make it happen.",
    lets_connect: "Let's Connect",
    chat_with_us: "Chat with us",
    message_placeholder: "Tell us more about your project...",
    success_message: "Request sent successfully!",
    form: {
      request_quote: "Request a Quote",
      full_name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      company: "Company",
      request_type: "Request Type",
      message: "Message",
      message_placeholder: "Tell us more about your project...",
      required: "This field is required",
      invalid_email: "Please enter a valid email address",
      invalid_phone: "Please enter a valid phone number",
      success: "Your message has been sent successfully!",
      error: "There was an error sending your message. Please try again.",
      submit: "Submit Request",
      submitting: "Sending...",
      validation_error: "Please fix the errors in the form before submitting.",
      success_message: "Your request has been submitted successfully!",
      error_message: "There was an error submitting your request. Please try again."
    },
    social: {
      follow: "Follow us on",
      connect: "Connect with us on",
      share: "Share on",
      whatsapp: "WhatsApp",
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      x: "X"
    },
    labels: {
      company: "Company",
      working_hours: "Working Hours",
      get_directions: "Get Directions",
      social_links: "Social Links",
      quick_contact: "Quick Contact"
    },
    aria: {
      contact_form: "Contact request form",
      social_links: "Social media links",
      contact_info: "Contact information",
      submit_button: "Submit contact form",
      close_message: "Close message"
    }
  },
  services: {
    titleStart: "Our",
    titleColored: "Services",
    subtitle: "Discover our comprehensive range of construction and engineering solutions tailored to meet your specific needs.",
    overview: "Overview",
    features: "Features",
    benefits: "Benefits",
    our_services: "Our Services",
    gallery: "Gallery",
  },
  projects: {
    title: "Our Projects",
    selected_projects: "Selected Projects",
    overview: "Project Overview",
    panorama: "Panoramic Views",
    gallery: "Project Gallery",
    type: "Project Type",
    city: "City",
    year: "Project Year",
    cost: "Project Cost",
    ongoing: "Ongoing",
    completed: "Completed",
    location: "Location",
  },
  footer: {
    navigation: "Navigation",
    services: "Services",
    contact: "Contact us",
    copyright: "© {{year}} YouniStone Co. All rights reserved."
  },
  validation: {
    required: "This field is required",
    name_min_length: "Name must be at least 3 characters long",
    email_invalid: "Please enter a valid email address",
    message_min_length: "Message must be at least 10 characters long"
  }
};

export default translations;

// Full Screen